export const environment = {
  production: false,
  apiUrl: 'https://uat-documents-ai.api.us.ey.com/',
  // Replace with your actual tenant ID
  scopes: [
    'profile',
    'email',
    'c95ce3e2-6d69-4c09-96be-7f5ee64a524f/user_impersonation',
  ], // Add any additional scopes you need
  profileUrl: 'https://graph.microsoft.com/v1.0/me/photo/$value', // URL to fetch the profile photo
  msalConfig: {
    auth: {
      clientId: 'c95ce3e2-6d69-4c09-96be-7f5ee64a524f',
      authority:
        'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c',
      redirectUri: 'https://uat-documents-ai.us.ey.com/', // Replace with your actual redirect URI
      postLogoutRedirectUri: 'https://uat-documents-ai.us.ey.com/logout', // Replace with your actual post logout redirect URI
    },
  },
  apiConfig: {
    scopes: ['c95ce3e2-6d69-4c09-96be-7f5ee64a524f/user_impersonation'],
    uri: 'https://uat-documents-ai.api.us.ey.com/',
  },
  sharepoint_url: '',
  sharepoint_path: '',
};
